import { render, staticRenderFns } from "./ProductTab.vue?vue&type=template&id=5ae57d12&"
import script from "./ProductTab.vue?vue&type=script&lang=js&"
export * from "./ProductTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports